export default "Ending,Case,Footnote\num,accusative,\nū,ablative,\n";